// PROFCORE-34854: thumbs up/down + dislike-feedback for the Key Points card on
// Condition pages. Independent of modules/shared.js's rating listeners/drawer and
// modules/bindui.js's feedback form — those are singletons wired to the AI Search
// modal's #feedbackDrawer and live Dify conversation state, so this owns its own.
//
// No /Event (difyApi.sendEvent) call here — that API logs query-level AI events, and
// Key Points isn't one. A dedicated pipeline is planned separately; wire it in once it
// exists. Only wmdPageLink fires, under an `ai-search_kpt-*` prefix so it can't collide
// with the AI Search modal's own like/dislike (`ai-search_*`) tracking on the same page.
var _initialized = false;

function toggleDrawer(open) {
    var drawer = document.getElementById('keyPointsFeedbackDrawer');
    if (!drawer) { return; }

    var form = document.getElementById('keyPointsFeedbackForm');
    var thankYou = document.getElementById('keyPointsFeedbackSuccessMsg');
    var otherText = document.getElementById('keyPointsOtherText');
    var title = document.getElementById('keyPointsFeedbackTitle');
    var intro = drawer.querySelector('.key-points-feedback-intro');

    if (open) {
        if (thankYou) { thankYou.style.display = 'none'; }
        if (form) { form.style.display = 'block'; }
        if (title) { title.style.display = 'block'; }
        if (intro) { intro.style.display = 'block'; }
        drawer.classList.add('active');
        // Lock page scroll behind the modal while it's open.
        document.body.classList.add('key-points-feedback-open');
    } else {
        drawer.classList.remove('active');
        if (form) { form.reset(); }
        if (otherText) { otherText.style.display = 'none'; }
        if (thankYou) { thankYou.style.display = 'none'; }
        if (title) { title.style.display = 'block'; }
        if (intro) { intro.style.display = 'block'; }
        document.body.classList.remove('key-points-feedback-open');
        drawer.querySelectorAll('.key-points-feedback-option').forEach(function(el) {
            el.classList.remove('checked');
        });
    }
}

// Swaps the dialog into its "thank you" state.
function showThankYou() {
    var form = document.getElementById('keyPointsFeedbackForm');
    var thankYou = document.getElementById('keyPointsFeedbackSuccessMsg');
    var title = document.getElementById('keyPointsFeedbackTitle');
    var drawer = document.getElementById('keyPointsFeedbackDrawer');
    var intro = drawer && drawer.querySelector('.key-points-feedback-intro');

    if (form) { form.style.display = 'none'; }
    if (title) { title.style.display = 'none'; }
    if (intro) { intro.style.display = 'none'; }
    if (thankYou) { thankYou.style.display = 'block'; }
}

function init() {
    if (_initialized) { return; }
    _initialized = true;

    document.addEventListener('click', function(e) {
        var target = e.target;
        if (!target || !target.closest) { return; }

        // closest() resolves clicks on the nested icon/text spans back to the button.
        var likeBtn = target.closest('.key-points-like');
        var dislikeBtn = target.closest('.key-points-dislike');
        var ratingBtn = likeBtn || dislikeBtn;

        if (ratingBtn) {
            var ratingContainer = ratingBtn.closest('.key-points-rating');
            if (!ratingContainer) { return; }

            var wasSelfSelected = ratingBtn.classList.contains('selected');
            var wasLikeSelected = !!ratingContainer.querySelector('.key-points-like.selected');
            var wasDislikeSelected = !!ratingContainer.querySelector('.key-points-dislike.selected');
            var isDislike = !!dislikeBtn;
            var isLike = !!likeBtn;

            ratingContainer.querySelectorAll('.key-points-like, .key-points-dislike').forEach(function(btn) {
                btn.classList.remove('selected');
                btn.setAttribute('aria-pressed', 'false');
            });

            // Clicking an already-selected button toggles it off — don't re-select or re-track.
            if (wasSelfSelected) { return; }

            ratingBtn.classList.add('selected');
            ratingBtn.setAttribute('aria-pressed', 'true');

            if (isLike && wasDislikeSelected && typeof wmdPageLink !== 'undefined') {
                wmdPageLink('ai-search_kpt-dislike-to-like', ratingBtn);
            }
            if (isDislike && wasLikeSelected && typeof wmdPageLink !== 'undefined') {
                wmdPageLink('ai-search_kpt-like-to-dislike', ratingBtn);
            }

            if (isLike) {
                if (typeof wmdPageLink !== 'undefined') { wmdPageLink('ai-search_kpt-like', ratingBtn); }
            } else if (isDislike) {
                toggleDrawer(true);
                if (typeof wmdPageLink !== 'undefined') { wmdPageLink('ai-search_kpt-dislike', ratingBtn); }
            }
            return;
        }

        // Close button, X icon, and overlay backdrop all just dismiss without a reason.
        var closeTarget = target.closest('.key-points-feedback-close-btn') ||
            target.closest('.key-points-feedback-cancel-btn') ||
            target.closest('.key-points-feedback-overlay');
        if (closeTarget) {
            toggleDrawer(false);
        }
    }, true);

    // Enter/Space activates the role="button" spans; the real <button> needs no help.
    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Enter' && e.key !== ' ') { return; }
        var target = e.target;
        if (!target || !target.classList) { return; }
        if (target.classList.contains('key-points-like') ||
            target.classList.contains('key-points-dislike') ||
            target.classList.contains('key-points-feedback-close-btn')) {
            e.preventDefault();
            target.click();
        }
    });

    document.addEventListener('change', function(e) {
        var target = e.target;
        if (!target || target.name !== 'kp-reason') { return; }

        var otherText = document.getElementById('keyPointsOtherText');
        if (target.checked) {
            if (otherText) { otherText.style.display = target.value === 'Other' ? 'block' : 'none'; }

            var drawer = document.getElementById('keyPointsFeedbackDrawer');
            if (drawer) {
                drawer.querySelectorAll('input[name="kp-reason"]').forEach(function(cb) {
                    if (cb !== target) {
                        cb.checked = false;
                        var cLabel = cb.closest('.key-points-feedback-option');
                        if (cLabel) { cLabel.classList.remove('checked'); }
                    }
                });
            }
        }

        var label = target.closest('.key-points-feedback-option');
        if (label) {
            label.classList.toggle('checked', target.checked);
        }
    });

    // Hide the placeholder on focus, not just once typing starts; restore on blur if empty.
    var otherTextEl = document.getElementById('keyPointsOtherText');
    if (otherTextEl) {
        var otherTextPlaceholder = otherTextEl.getAttribute('placeholder') || '';
        otherTextEl.addEventListener('focus', function() {
            otherTextEl.setAttribute('placeholder', '');

            // Short viewports scroll the dialog internally — scroll to full height so the
            // Close/Submit row (and the padding below it) is visible.
            var dialog = document.querySelector('#keyPointsFeedbackDrawer .key-points-feedback-dialog');
            if (dialog) {
                dialog.scrollTo({ top: dialog.scrollHeight, behavior: 'smooth' });
            }
        });
        otherTextEl.addEventListener('blur', function() {
            otherTextEl.setAttribute('placeholder', otherTextPlaceholder);
        });
    }

    var form = document.getElementById('keyPointsFeedbackForm');
    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            var reasonChecked = false;
            var optionIndex;
            form.querySelectorAll('input[name="kp-reason"]').forEach(function(el, index) {
                if (el.checked) {
                    reasonChecked = true;
                    optionIndex = index + 1;
                }
            });
            if (!reasonChecked) { return; }

            if (typeof wmdPageLink !== 'undefined') {
                wmdPageLink('ai-search_kpt-feedback-' + optionIndex, e.target);
            }

            showThankYou();
            setTimeout(function() {
                toggleDrawer(false);
            }, 6000);
        });
    }
}

module.exports = {
    init: init
};
